import type { FC } from 'react';

import * as styles from './RewardBadges.css';

interface RewardBadgesProps {
  readonly loyaltyPoints?: number;
  readonly otherRewards?: number;
}

const LOYALTY_ICON_URL =
  'https://cdn.xsolla.net/image-proxy/rs:fit:1920:0/f:webp/storage/merchant-bucket-prod/files/uploaded/sitebuilder/439172/7ba9c15b409cc304879e7bb3996044c0.png@webp';
const BUBBLE_ICON_URL =
  'https://cdn.xsolla.net/image-proxy/rs:fit:3840:0/f:webp/storage/merchant-bucket-prod/files/uploaded/sitebuilder/439172/7644fde0325be584e0fee79a47450e14.png@webp';

export const RewardBadges: FC<RewardBadgesProps> = ({
  loyaltyPoints,
  otherRewards,
}) => {
  if (!loyaltyPoints && !otherRewards) return null;

  return (
    <div className={styles.container}>
      {!!loyaltyPoints && loyaltyPoints > 0 && (
        <div className={`${styles.badge} ${styles.bubbleBadge}`}>
          <img src={BUBBLE_ICON_URL} alt='Loyalty' className={styles.icon} />
          <span className={`${styles.value} ${styles.bubbleValue}`}>
            {loyaltyPoints}
          </span>
        </div>
      )}
      {!!otherRewards && otherRewards > 0 && (
        <div className={`${styles.badge} ${styles.loyaltyBadge}`}>
          <img
            src={LOYALTY_ICON_URL}
            alt='Other Rewards'
            className={styles.icon}
          />
          <span className={`${styles.value} ${styles.loyaltyValue}`}>
            {otherRewards}
          </span>
        </div>
      )}
    </div>
  );
};
